import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sippa-registration',
  templateUrl: './sippa-registration.component.html',
  styleUrls: ['./sippa-registration.component.css']
})
export class SippaRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
